export const GET_MEETING_GROUPS = `
  query GetMeetingGroups($input: GetMeetingGroupsInput!) {
    meetingGroups(input: $input) {
      id
      tenant_id
      meeting_id
      group_id
      group {
        id
        name
        monthly_date
      }
      meeting {
        id
        month
        current_date
        type
      }
    }
  }
`;

export const GET_MEETING_GROUPS_BY_MEETING = `
  query GetMeetingGroupsByMeeting($meeting_id: Int!, $tenant_id: Int!) {
    meetingGroups(input: { meeting_id: $meeting_id, tenant_id: $tenant_id }) {
      id
      tenant_id
      meeting_id
      group_id
      group {
        id
        name
        monthly_date
      }
      meeting {
        id
        month
        current_date
        type
      }
    }
  }
`;
